<fgb-navigation-indicator></fgb-navigation-indicator>

<fgb-mobile-nav-menu *ifScreenSize="screenSize.Mobile"></fgb-mobile-nav-menu>
<fgb-nav-bar *ifScreenSize="screenSize.Desktop"></fgb-nav-bar>

<ng-container *ifScreenSize="screenSize.Desktop">
  <fgbcl-notification-toast></fgbcl-notification-toast>
</ng-container>

<div id="main">
  <router-outlet></router-outlet>
</div>

<fgb-footer></fgb-footer>
